import { FontWeightBold, FontSize100, FontSize300, RadiusMd } from "@nxt-costco-com/forge-design-tokens";
import { responsiveStyles } from "../responsiveStyles.js";
const containerStyles = {
  cursor: "pointer",
  margin: "auto"
};
const linkStyles = {
  "&:hover": {
    borderRadius: RadiusMd,
    outline: `2px solid #003399`,
    outlineOffset: "1px",
    textDecoration: "none"
  },
  alignItems: "center",
  border: "2px solid transparent",
  color: "#003399",
  display: "flex",
  justifyContent: "flex-start"
};
const titleStyles = {
  color: "#003399",
  fontSize: { md: FontSize300, xs: FontSize100 },
  fontWeight: FontWeightBold,
  textAlign: "left"
};
const imageStyles = {
  margin: "auto",
  maxWidth: "100%",
  ...responsiveStyles
};
const costcoInlineSxObj = {
  containerStyles,
  imageStyles,
  linkStyles,
  titleStyles
};
export {
  costcoInlineSxObj
};
